import { Inject } from 'inversify-props'
import type { RegraDeAplicacaoServiceAdapter } from '../adapter'

export class DeleteRegraDeAplicacaoUseCase {
	@Inject('RegraDeAplicacaoServiceAdapter')
	private regraService!: RegraDeAplicacaoServiceAdapter

	delete = async (id: string) => await this.regraService.delete(id)
}
